import { mdiMagnify, mdiMenu } from '@mdi/js'
import contentApi from '@/api/content'
import firebase from '@/api/firebase'
export default {
  data: () => ({
    user: null,
    showProgressCircular: false,
    // TODO(vignatti): Move experiencesContent, count, searchQuery and area all
    // inside 'experiences' array
    experiencesContent: {
      '360': [],
      'labs': [],
      '3d': [],
    },
    count: {
      '360': 0,
      'labs': 0,
      '3d': 0,
    },
    searchQuery: {
      '360': '',
      'labs': '',
      '3d': '',
    },
    area: {
      '360': '',
      'labs': '',
      '3d': '',
    },
    mdiMagnify, mdiMenu,
    size: 10,
    nextToken: {
      '360': '',
      'labs': '',
      '3d': '',
    },
    experienceType: '',
    experienceQuery: '',
  }),
  watch: {
    '$route.query.type'(val) {
      this.experienceType = val

      this.setTypeQueryAndSearch(this.experienceType, this.experienceQuery)
    },
    '$route.query.query'(val) {
      this.experienceQuery = val

      this.setTypeQueryAndSearch(this.experienceType, this.experienceQuery)
    },
  },
  mounted () {
    // TODO(vignatti): we want to use Vuex instead
    this.$bus.$on('search-experience-area', (searchArea) => {
      this.setAreaAndSearch(searchArea)
    })

    this.$bus.$on('handle-infinite-scroll', () => {
      this.getExperiences(
          this.experienceType,
          this.searchQuery[this.experienceType],
          this.area[this.experienceType])
    })

    this.experienceType = this.$route.query.type
    this.experienceQuery =  this.$route.query.query

  },
  // TODO(vignatti): remove async / await pair from creation time
  async created() {
    this.showProgressCircular = true
    await this.getUserByEmail()
    await this.getUserData()
    this.getExperiences()
    this.showProgressCircular = false
  },
  methods: {
    async getUserByEmail() {
      let vm = this
      let params = {
        'userEmail' : JSON.parse(localStorage.getItem('user')).email
      }
      let userForEmail = await firebase.getUserByEmail(params)
      userForEmail.forEach(
        await function(doc) {
          vm.user = {}
          vm.user.uid = doc.id
          vm.user.role = doc.data().role
          vm.user.displayName = JSON.parse(localStorage.getItem('user')).displayName
        }
      )
    },
    async getUserData() {
      let vm = this
      let experiences = []
      let i = 0
      let params = {
        'userId' : this.user.uid
      }
      let data = await firebase.getUserLists(params)
      data.forEach (
        await function(doc) {
          experiences.push(doc.data())
          experiences[i].name = doc.id
          vm.user.lists = experiences
          i += 1
        }
      )
    },

    setTypeQueryAndSearch(type, query) {
      this.getExperiences(type, query, this.area[type])
    },

    setAreaAndSearch(area) {
      this.getExperiences(this.experienceType, this.searchQuery[this.experienceType], area)
    },

    clearContent(type) {
      this.nextToken[type] = ''
      this.experiencesContent[type] = []
    },

    getExperiences(type = this.experienceType, query = this.experienceQuery, area = '') {
      // Clear content for an experience type if any of the
      // query parameters have changed
      if (this.searchQuery[type] !== query || this.area[type] !== area) {
        this.searchQuery[type] = query
        this.area[type] = area
        this.clearContent(type)
      }

      // "$refs are only populated after the component has been rendered, and
      // they are not reactive. It is only meant as an escape hatch for direct
      // child manipulation - you should avoid accessing $refs from within
      // templates or computed properties.",
      //  https://vuejs.org/v2/guide/components-edge-cases.html#Accessing-Child-Component-Instances-amp-Child-Elements,
      //
      // Based on the official doc, we may want to get rid of $refs in the
      // future to 'undefined' cases like the following lines.

      this.getExperiencesByType(type)
      .then(items => {
        if (items.length) {
          this.experiencesContent[type] = this.experiencesContent[type].concat(items)
        }
      })
    },

    getExperiencesByType(type) {
      // Prevent further searches after hitting the end of the results
      if (this.nextToken[type] === null)
        return Promise.resolve([])

      return contentApi.searchLearningObjects(type, this.searchQuery[type], this.area[type], this.size, this.nextToken[type])
      .then(list => {
        this.count[type] = list.total
        this.nextToken[type] = list.nextToken
        return list.items
      })
      .catch((error) => {
        console.error(error)
        return Promise.resolve([])
      })
    },
  }
}
